module.exports = __webpack_public_path__ + "static/app-shot-1-3-1aeed6c5cf173fad161c6de07d20c238.jpg";